import type {SharedJobDetailedScanResult} from "../../../3-perform-scan/scan-model/SharedJobResult.ts";
import type {SharedJobMigrationJson, SharedJobMigrationOrchJson} from "./sharedJobMigrationJson.ts";
import {
    getSharedJobImplementationId
} from "../../../../components/scanner/shared-job-scanner/SharedJobImplementationId.ts";

export function generateSharedJobMigrationJson(scan: SharedJobDetailedScanResult): SharedJobMigrationJson | undefined {
    try {
        const components = scan.jobs.map<SharedJobMigrationOrchJson>((x) => ({
            id: "unknown-to-run-shared-pipeline",
            metlImplementationId: getSharedJobImplementationId(x.metadata.identifier.packageName, x.metadata.identifier.name, x.metadata.identifier.revision),
            metlName: x.metadata.identifier.name,
            metlRevision: x.metadata.identifier.revision,
            parameters: x.metadata.rootJobReference.parameterMetadata.map((param) => ({
                variable: param.variableName,
                variableType: param.variableType,
                metlName: param.displayName
            }))
        }))
        return {
            transformationComponents: [],
            orchestrationComponents: components
        }
    } catch (e) {
        console.error("Failed to generate shared job migration json", e)
        return undefined
    }
}